module.exports = __webpack_public_path__ + "img/hi.2db87b8f.jpg";